export default __webpack_public_path__ + "static/5-b91cb3ac02aed88789938b1a3eb2f99f.jpg";